import {
  SHOW_NOTIFICATION_DIALOG_MANUAL_0RDER,
  HIDE_NOTIFICATION_DIALOG_MANUAL_0RDER,
} from "../actions/action-type";

const initialState = {
  isShowing: false,
  title: "",
  content: "",
  button: "",
};

const notificationManualOrderReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_NOTIFICATION_DIALOG_MANUAL_0RDER:
      return {
        ...state,
        isShowing: true,
        title: payload.title,
        content: payload.content,
        button: payload.button,
        url: payload.url,
      };
    case HIDE_NOTIFICATION_DIALOG_MANUAL_0RDER:
      return initialState;

    default:
      return state;
  }
};

export default notificationManualOrderReducer;
